import { render, staticRenderFns } from "./searchCom.vue?vue&type=template&id=0a4f7665&scoped=true"
import script from "./searchCom.vue?vue&type=script&lang=js"
export * from "./searchCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f7665",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4f7665')) {
      api.createRecord('0a4f7665', component.options)
    } else {
      api.reload('0a4f7665', component.options)
    }
    module.hot.accept("./searchCom.vue?vue&type=template&id=0a4f7665&scoped=true", function () {
      api.rerender('0a4f7665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/handoverException/component/searchCom.vue"
export default component.exports